import type { RouteRecordRaw } from "vue-router";

export const BiRoutes: RouteRecordRaw[] = [
    {
        path: ':id',
        name: 'biView',
        component: () => import('./components/view/BiView.vue'),
    }
]